import React, { useState } from "react";
import { Button, Stack, TextField } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const NewReleaseForm = (params) => {
  const { scriptName, onSubmit } = params;
  const [rubricName, setRubricName] = useState(scriptName);
  const [rubricVersion, setRubricVersion] = useState("latest");

  const handleRubricNameChange = (event) => {
    setRubricName(event.target.value);
  };

  const handleRubricVersionChange = (event) => {
    setRubricVersion(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(scriptName, rubricName, rubricVersion);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
        <Button
          variant="contained"
          startIcon={<AddCircleIcon />}
          color="success"
          type="submit"
          sx={{ minWidth: { md: 200 }, whiteSpace: "nowrap" }}
        >
          Create New Release
        </Button>
        <TextField
          id="rubricName"
          type="text"
          name="rubricName"
          label="Rubric Name"
          value={rubricName}
          onChange={handleRubricNameChange}
          variant="outlined"
          fullWidth
        />
        <TextField
          id="rubricVersion"
          type="text"
          name="rubricVersion"
          label="Rubric Version"
          value={rubricVersion}
          onChange={handleRubricVersionChange}
          variant="outlined"
          fullWidth
        />
      </Stack>
    </form>
  );
};

export default NewReleaseForm;
